import * as React from 'react';
import { BuildIcon } from '../../components/Icons/BuildIcon';
import { ShipIcon } from '../../components/Icons/ShipIcon';
import { DecksIcon } from '../../components/Icons/DecksIcon';
import { PeopleIcon } from '../../components/Icons/PeopleIcon';
import { StarIcon } from '../../components/Icons/StarIcon';
import * as vars from '../../consts/variables';
import { style } from './RecommendationSection';
import { IShip } from '../../reducers/companyDetailPage';
import { PriceWithDiscount } from './PriceWithDiscount';
import { Feature } from '@paralleldrive/react-feature-toggles';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const shipListSpacingBottom: any = {
    flex: '0 0 50%',
    minWidth: 0,
};
const shipTitleStyle: any = {
    textShadow: `0 0 4px ${vars.darkBlack}`,
};

const starsWrapperStyle: any = {
    display: 'inline-block',
};

const getIconStyles = (theme) => {
    return css`
        float: left;
        margin-right: 5px;
        fill: ${theme.icon.brandColor1};
        flex: 0 0 auto;
    `;
};

const ShipIconStyled = styled(ShipIcon)`
    ${({ theme }) => getIconStyles(theme)};
`;

const BuildIconStyled = styled(BuildIcon)`
    ${({ theme }) => getIconStyles(theme)};
`;

const DecksIconStyled = styled(DecksIcon)`
    ${({ theme }) => getIconStyles(theme)};
`;

const PeopleIconStyled = styled(PeopleIcon)`
    ${({ theme }) => getIconStyles(theme)};
`;

function getShipProperties(data) {
    const shipProperties = ['numDecks', 'length', 'passengers', 'manufactureYear'];
    let result = [];
    shipProperties.forEach((properties) => {
        const shipProperties = data[properties];
        if (shipProperties) {
            switch (properties) {
                case 'numDecks':
                    result.push(
                        <div style={shipListSpacingBottom}>
                            <DecksIconStyled width={18} height={18} />
                            <span
                                className="overflow-ellipsis--single-line"
                                style={style.teaserText}
                            >
                                {shipProperties}
                            </span>
                        </div>,
                    );
                    break;
                case 'passengers':
                    result.push(
                        <div style={shipListSpacingBottom}>
                            <PeopleIconStyled width={16} height={18} />
                            <span
                                className="overflow-ellipsis--single-line"
                                style={style.teaserText}
                            >
                                {shipProperties}
                            </span>
                        </div>,
                    );
                    break;
                case 'manufactureYear':
                    result.push(
                        <div style={shipListSpacingBottom}>
                            <BuildIconStyled width={18} height={18} />
                            <span
                                className="overflow-ellipsis--single-line"
                                style={style.teaserText}
                            >
                                {shipProperties}
                            </span>
                        </div>,
                    );
                    break;
                case 'length':
                    result.push(
                        <div style={shipListSpacingBottom}>
                            <ShipIconStyled width={18} height={18} />
                            <span
                                className="overflow-ellipsis--single-line"
                                style={style.teaserText}
                            >
                                {shipProperties}
                            </span>
                        </div>,
                    );
                    break;
            }
        }
    });
    return result;
}

interface IProps {
    deviceType?: string;
    ships: IShip[];
    logo?: string;
}

export function shipList(props: IProps) {
    const { ships, deviceType } = props;
    return ships.map((val, key) => {
        const iconStyle: any = {
            marginLeft: 0,
            fill: vars.white,
        };
        const category = [];
        for (let i = 0; i < val.category; i++) {
            const starStyle = i === 0 ? { ...iconStyle, marginLeft: 10 } : iconStyle;
            category.push(
                <StarIcon dropShadow="dark" key={i} width={14} height={14} style={starStyle} />,
            );
        }
        const teaserTitle = val.title ? (
            <div style={style.teaserTitle}>
                <span style={shipTitleStyle} dangerouslySetInnerHTML={{ __html: val.title }} />
                <Feature
                    name="showReviews"
                    activeComponent={() =>
                        category.length > 0 ? <div style={starsWrapperStyle}>{category}</div> : null
                    }
                />
            </div>
        ) : null;
        const shipProps = getShipProperties(val);
        const priceProps = {
            price: val.minPriceDualCurrency || val.minPrice,
            discount: val.maxPercentDiscount,
            currency: val.dualCurrency || val.currency,
        };
        const child = (
            <div>
                <div style={style.card}>
                    <div style={style.cardInfo}>
                        {shipProps.length > 0 && (
                            <div style={style.shipListWrapper}>
                                {shipProps.length > 0 && shipProps[0]}
                                {shipProps.length > 1 && shipProps[1]}
                            </div>
                        )}
                        {shipProps.length > 2 && (
                            <div style={style.shipListWrapper}>
                                {shipProps.length > 2 && shipProps[2]}
                                {shipProps.length > 3 && shipProps[3]}
                            </div>
                        )}
                    </div>
                    <PriceWithDiscount {...priceProps} />
                </div>
                <div style={style.shipListDescWrapper}>
                    <div
                        className={deviceType !== 'desktop' ? 'overflow-ellipsis--multi-line' : ''}
                    >
                        {val.teaserDescription}
                    </div>
                </div>
            </div>
        );
        return {
            child: child,
            url: val.url,
            companyImage: props.logo || val.logoImageUrl || null,
            teaserTitle: teaserTitle,
            imageSrc: val.teaserImage || val.teaserImageUrl || null,
            imageAlt: val.title,
        };
    });
}
